"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CentrifugeService = void 0;

var _centrifuge = _interopRequireDefault(require("centrifuge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CentrifugeService =
/*#__PURE__*/
function () {
  function CentrifugeService() {
    _classCallCheck(this, CentrifugeService);

    _defineProperty(this, "subscribers", void 0);

    _defineProperty(this, "centrifuge", void 0);

    _defineProperty(this, "isConnected", void 0);

    this.subscribers = {};
    this.centrifuge = null;
    this.connectionData = null;
    this.isConnected = false;
  }

  _createClass(CentrifugeService, [{
    key: "connect",
    value: function connect(_ref) {
      var _this = this;

      var connectionData = _ref.connectionData,
          onConnect = _ref.onConnect,
          onDisconnect = _ref.onDisconnect,
          options = _ref.options;
      this.centrifuge = new _centrifuge["default"](connectionData, options);

      if (this.centrifuge) {
        this.centrifuge.connect();
        this.centrifuge.on('connect', function (context) {
          onConnect(context);
          _this.isConnected = true;
          _this.connectionData = connectionData;

          _this.initChannels();
        });
        this.centrifuge.on('disconnect', onDisconnect);
      }
    } // todo переписать остановку всех каналов
    // stopChannels() {
    //     Object.keys(this.subscribers).forEach((channel) => {
    //         this.subscribers[channel].forEach((channelHandler) => {
    //             if (!this.subscriptions[channel] && this.subscriptions[channel][channelHandler]) {
    //                 this.subscriptions[channel][channelHandler].unsubscribe();
    //             }
    //         });
    //     });
    //     this.subscriptions = {};
    // }

  }, {
    key: "splitChannelInfo",
    value: function splitChannelInfo(channelName) {
      var splittedChannelName = channelName.split('.');
      return {
        channelName: splittedChannelName[0],
        subscriberId: splittedChannelName[1]
      };
    }
  }, {
    key: "getSubscription",
    value: function getSubscription(channelInfo) {
      var _this$splitChannelInf = this.splitChannelInfo(channelInfo),
          channelName = _this$splitChannelInf.channelName,
          subscriberId = _this$splitChannelInf.subscriberId;

      return this.subscribers[channelName][subscriberId].subscription;
    }
  }, {
    key: "subscribeChannel",
    value: function subscribeChannel(channelInfo, handler, otherSettings) {
      var _this$splitChannelInf2 = this.splitChannelInfo(channelInfo),
          channelName = _this$splitChannelInf2.channelName,
          subscriberId = _this$splitChannelInf2.subscriberId;

      if (!this.subscribers[channelName]) {
        this.subscribers[channelName] = {};
      }

      if (!this.subscribers[channelName][subscriberId]) {
        var callbacks = _objectSpread({}, otherSettings, {
          message: handler,
          publish: handler
        });

        this.subscribers[channelName][subscriberId] = {
          callbacks: callbacks,
          onConnect: callbacks.onConnect,
          subscription: null
        };
      }

      if (this.isConnected) {
        this.startSubscribe(channelName, this.subscribers[channelName][subscriberId]);
      }
    }
  }, {
    key: "unsubscribeChannel",
    value: function unsubscribeChannel(channelInfo) {
      var _this$splitChannelInf3 = this.splitChannelInfo(channelInfo),
          channelName = _this$splitChannelInf3.channelName,
          subscriberId = _this$splitChannelInf3.subscriberId;

      if (this.subscribers[channelName] && this.subscribers[channelName][subscriberId] && this.subscribers[channelName][subscriberId].subscription) {
        this.subscribers[channelName][subscriberId].subscription.unsubscribe();
      }
    }
  }, {
    key: "initChannels",
    value: function initChannels() {
      var _this2 = this;

      if (this.isConnected) {
        Object.keys(this.subscribers).forEach(function (channelName) {
          Object.keys(_this2.subscribers[channelName]).forEach(function (subscriberId) {
            var subscriber = _this2.subscribers[channelName][subscriberId];

            _this2.startSubscribe(channelName, subscriber);
          });
        });
      }
    }
  }, {
    key: "startSubscribe",
    value: function startSubscribe(channelName, subscriber) {
      if (!subscriber.subscription) {
        subscriber.subscription = this.centrifuge.subscribe(channelName, subscriber.callbacks);
      } else {
        subscriber.subscription.subscribe();

        if ('function' === typeof subscriber.onConnect) {
          subscriber.onConnect(subscriber.subscription);
        }
      }
    }
  }]);

  return CentrifugeService;
}();

exports.CentrifugeService = CentrifugeService;